//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MessageWithoutHeader from '@/components/Shared/MessageWithoutHeader.vue'
import AddColaboratorModalProjectDetail from '@/components/Projects/Detail/Tabs/Collaborators/AddColaboratorModalProjectDetail.vue'
import ModalResendInvitationMassive from '@/components/Projects/users/ModalResendInvitationMassive.vue'
import { showSuccessNotification } from '@/util/notifications'
import handleErrorMixin from '@/mixins/handleErrorMixin'
import ModalErrorUsers from '@/components/Projects/users/ModalErrorUsers.vue'
import CustomInvitationModal from '../Modals/CustomInvitationModal.vue'
import CollaboratorContainer from './Collaborators/CollaboratorContainer.vue'
import HeaderToolsBar from './Collaborators/HeaderToolsBar.vue'
import MultiselectBar from './Collaborators/MultiselectBar.vue'
import CollaboratorTable from './Collaborators/Table/CollaboratorTable.vue'
import MassiveImportCollaboratorProjectDetailModal from './Collaborators/MassiveImportCollaboratorProjectDetailModal.vue'
import MassiveImportInfoCollaboratorProjectDetailModal from './Collaborators/MassiveImportInfoCollaboratorProjectDetailModal.vue'
import { INVITATION_TO_PROJECT } from '~/constants/reminder-email-templates'
import ConfirmRegisterMassiveUser from '~/components/Invitation/ConfirmRegisterMassiveUser.vue'
import ROLES from '~/constants/roles'
export default {
  components: {
    MessageWithoutHeader,
    CollaboratorContainer,
    HeaderToolsBar,
    MultiselectBar,
    CollaboratorTable,
    AddColaboratorModalProjectDetail,
    MassiveImportCollaboratorProjectDetailModal,
    MassiveImportInfoCollaboratorProjectDetailModal,
    ModalResendInvitationMassive,
    CustomInvitationModal,
    ConfirmRegisterMassiveUser,
    ModalErrorUsers,
  },
  mixins: [handleErrorMixin],
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.projectSupervisors = await this.$repository.user.findSupervisorsByProject(
      {
        project: this.project.id,
      }
    )
    this.getCollaborators()
  },
  data() {
    return {
      search: {
        names: '',
        supervisors: [],
        stateInvitation: [],
      },
      selectedRows: [],
      companyEmployees: [],
      collaboratorsWithAssignedSupervisor: [],
      collaboratorsWithProjectRoles: [],
      projectSupervisors: [],
      supervisorId: null,

      // Modals
      isShowModalCollaborators: false,
      isShowModalMassiveImportCollaborator: false,
      isShowModalInfoMassiveImportCollaborator: false,
      isShowModalResendMassive: false,
      isShowModalConfirmRegisterMassiveUser: false,
      isShowModalCustomInvitation: false,
      collaboratorsMassiveImportInfo: [],

      emailTemplate: INVITATION_TO_PROJECT,
      roleType: ROLES.EMPLOYEE,

      baseUrl: process.env.NUXT_ENV_SEO_URL || 'http://0.0.0.0:3000',

      textModalErrorUsers: '',
      isShowModalErrorUsers: false,
    }
  },
  computed: {
    collaborators() {
      let collaborators = this.collaboratorsWithAssignedSupervisor
      if (this.search.supervisors.length > 0) {
        collaborators = collaborators.filter((collaborator) =>
          this.search.supervisors.includes(collaborator.supervisor?.id || null)
        )
      }
      if (this.search.stateInvitation.length > 0) {
        collaborators = collaborators.filter((collaborator) => {
          return this.search.stateInvitation.includes(
            collaborator.collaborator.show_change_password_modal
          )
        })
      }
      if (this.search.names.trim() === '') {
        return collaborators
      }
      return collaborators.filter((supervisorAssignment) => {
        return (
          supervisorAssignment.collaborator.names
            .toLowerCase()
            .includes(this.search.names.toLowerCase()) ||
          supervisorAssignment.collaborator.lastnames
            .toLowerCase()
            .includes(this.search.names.toLowerCase())
        )
      })
    },
    supervisorsList() {
      const supervisors = this.projectSupervisors.map((supervisor) => ({
        key: supervisor.id,
        name: `${supervisor.names} ${supervisor.lastnames}`,
      }))
      supervisors.push({
        key: null,
        name: this.$t('projects.projectDetailTab.withoutSupervisor'),
      })
      return supervisors
    },
    totalCollaboratorsWithoutSupervisor() {
      return this.collaboratorsWithAssignedSupervisor.filter(
        (collaborator) => !collaborator.supervisor
      ).length
    },
    urlProject() {
      return `${this.baseUrl}/invitacion/${this.project.code}`
    },
  },
  methods: {
    changeChecked(rows) {
      this.selectedRows = rows
    },
    async findEmployeesByCompany(companyId) {
      const companyEmployees = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: companyId,
        }
      )
      return companyEmployees.map((employee) => {
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.project.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          projectRole: projectRole || null,
        }
      })
    },
    async getCollaborators() {
      this.companyEmployees = await this.findEmployeesByCompany(
        this.project.company
      )

      this.collaboratorsWithAssignedSupervisor = await this.$repository.projectRoles.findWithSupervisorAssignmentByProjectId(
        this.project.id
      )

      this.collaboratorsWithProjectRoles = this.collaboratorsWithAssignedSupervisor.map(
        (collaboratorWithSupervisor) => {
          const collaborator = collaboratorWithSupervisor.collaborator
          const projectRole = collaboratorWithSupervisor.collaborator.project_roles?.find(
            (projectRole) =>
              projectRole.project === this.project.id &&
              projectRole.deleted_at === null
          )
          return {
            ...collaborator,
            projectRole: projectRole || null,
          }
        }
      )
    },
    async handleSaveCollaborator() {
      await this.getCollaborators()
      this.isShowModalCollaborators = false
    },
    sendCollaboratorsDetails({ collaborators, supervisorId }) {
      this.collaboratorsMassiveImportInfo = collaborators
      this.supervisorId = supervisorId
      this.isShowModalMassiveImportCollaborator = false
      this.isShowModalInfoMassiveImportCollaborator = true
    },
    finishMassiveCollaborator() {
      this.isShowModalInfoMassiveImportCollaborator = false
      this.isShowModalCollaborators = false
      this.getCollaborators()
    },
    toggleModalCollaborators() {
      this.isShowModalCollaborators = !this.isShowModalCollaborators
    },
    toggleModalMassiveImportCollaborator() {
      this.isShowModalMassiveImportCollaborator = !this
        .isShowModalMassiveImportCollaborator
    },
    toggleMassiveResend() {
      this.isShowModalResendMassive = !this.isShowModalResendMassive
    },
    toogleModalConfirmRegisterMassiveUser() {
      this.isShowModalConfirmRegisterMassiveUser = !this
        .isShowModalConfirmRegisterMassiveUser
    },
    toggleCustomInvitationModal() {
      this.isShowModalCustomInvitation = !this.isShowModalCustomInvitation
    },
    onEdit(project) {
      this.$emit('edit', project)
      this.isShowModalCustomInvitation = false
    },
    handleConfirmResendMassiveInvitation() {
      this.selectedRows = []
      this.toggleMassiveResend()
      this.toogleModalConfirmRegisterMassiveUser()
    },
    async handleDeleteUser(userId) {
      this.collaboratorsWithAssignedSupervisor = this.collaboratorsWithAssignedSupervisor.filter(
        (collaborator) => collaborator.collaborator.id !== userId
      )
      await this.getCollaborators()
      showSuccessNotification(
        this,
        'El usuario ha sido retirado exitosamente del proyecto.',
        3000
      )
    },
    async handleSelectSupervisor({ supervisorAssignment, rowAssignment }) {
      await this.handleAsiggnSupervisor({
        supervisorAssignmentId: rowAssignment.id,
        supervisorId: supervisorAssignment.supervisorId,
        projectId: supervisorAssignment.projectId,
      })
      await this.getCollaborators()
    },
    async handleAsiggnSupervisor({
      supervisorAssignmentId,
      supervisorId,
      projectId,
    }) {
      try {
        this.$store.commit('loading', true)
        await this.$repository.supervisorAssignments.updateDefaultAssignment(
          supervisorAssignmentId,
          {
            projectId,
            supervisorId,
          }
        )

        await this.$repository.projectRoles.updateValidationStatus(
          projectId,
          supervisorId,
          true
        )
        showSuccessNotification(this, 'Supervisor asignado correctamente', 3000)
      } catch (error) {
        this.handleError(error, 'Error al asignar el supervisor')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    searchInputChange(value) {
      this.search.names = value
    },
    onSearch(filters) {
      this.search.names = filters?.names || ''
      this.search.supervisors = filters?.supervisors || []
      this.search.stateInvitation = filters?.stateInvitation || []
    },
    toogleModalErrorUsers() {
      this.isShowModalErrorUsers = !this.isShowModalErrorUsers
    },
    handleUserWithError(message) {
      this.textModalErrorUsers = message
      this.isShowModalErrorUsers = true
    },
  },
}
